module.exports = __webpack_public_path__ + "static/analytics-new-product@2x-4c70f2ded1cfd2cf76b7e676b58eb126.png";